import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  archiveNotification,
  deleteNotification,
  fetchNotifications,
  markAllNotificationsRead,
  markNotificationRead,
} from '../api/notifications';
import type { NotificationList } from '../types';

const KEY = ['notifications'];

export function useNotifications(enabled = true) {
  return useQuery<NotificationList>({
    queryKey: KEY,
    queryFn: fetchNotifications,
    enabled,
  });
}

export function useUnreadCount(enabled: boolean) {
  return useQuery<NotificationList, unknown, number>({
    queryKey: KEY,
    queryFn: fetchNotifications,
    enabled,
    select: (data) => data.unreadCount,
  });
}

export function useNotificationActions() {
  const qc = useQueryClient();
  const invalidate = () => qc.invalidateQueries({ queryKey: KEY });
  return {
    markRead: useMutation({ mutationFn: markNotificationRead, onSuccess: invalidate }),
    markAllRead: useMutation({ mutationFn: markAllNotificationsRead, onSuccess: invalidate }),
    archive: useMutation({ mutationFn: archiveNotification, onSuccess: invalidate }),
    remove: useMutation({ mutationFn: deleteNotification, onSuccess: invalidate }),
  };
}
